const CardIcon = () => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.66675 7.32227H18.3334"
      stroke="#91A2BB"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 13.9883H6.66667"
      stroke="#91A2BB"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.75 13.9883H12.0833"
      stroke="#91A2BB"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.36675 3.15527H14.6251C17.5917 3.15527 18.3334 3.88861 18.3334 6.81361V13.6553C18.3334 16.5803 17.5917 17.3136 14.6334 17.3136H5.36675C2.40841 17.3219 1.66675 16.5886 1.66675 13.6636V6.81361C1.66675 3.88861 2.40841 3.15527 5.36675 3.15527Z"
      stroke="#91A2BB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default CardIcon;
